import {
  FETCH_USER_NOTIFICATIONS,
  FETCH_USER_NOTIFICATIONS_SUCCESS,
  FETCH_USER_NOTIFICATIONS_FAILED,

  UPDATE_USER_NOTIFICATIONS,
  UPDATE_USER_NOTIFICATIONS_SUCCESS,
  UPDATE_USER_NOTIFICATIONS_FAILED,
} from "../store/types";

const initialState = {
  loading: false,
  notifications: [],
  error: null,
};

export const notificationsreducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_NOTIFICATIONS:
    case UPDATE_USER_NOTIFICATIONS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_USER_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload,
        error: null,
      };

    case UPDATE_USER_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case FETCH_USER_NOTIFICATIONS_FAILED:
    case UPDATE_USER_NOTIFICATIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
